<style scoped lang="scss">
  @import '@/assets/styles/variables.scss';
  .drawer {
    width: 300px;
    padding: 20px;
  }

  .icon {
    margin-bottom: 15px;
    margin-top: -10px;
    margin-right: -10px;
    color: hsl(0, 0, 40);
    cursor: pointer;
    font-size: 25px;
    &:hover {
      opacity: 0.7;
    }
  }
</style>


<template>
  <div class="drawer flex-v flex-limit">
    <div class="flex-h flex-limit flex-justify-end">
      <c-icon icon="fa-times" @click.native="$emit('close')"></c-icon>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>


<script>
export default {
  name: 'drawer'
};
</script>
